// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"28":"filters","87":"select2","218":"expands","287":"archive-filter-toggle","932":"archive-short-code"}[chunkId] + "-cg-archive-shortcode-frontend.production.bundle.min.js";
};